import { Component, Inject } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { AddNewFolderDialogModel } from './add-new-folder-dialog.model'

@Component({
    selector: 'app-add-new-folder-dialog',
    templateUrl: './add-new-folder-dialog.component.html',
    styleUrls: ['./add-new-folder-dialog.component.scss'],
})
export class AddNewFolderDialogComponent {
    constructor(
        private readonly dialogRef: DialogRef<string>,
        @Inject(DIALOG_DATA) readonly data: AddNewFolderDialogModel
    ) {}

    confirm(folderName: string): void {
        this.dialogRef.close(folderName)
    }

    cancel(): void {
        this.dialogRef.close()
    }
}
